import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { BaseCardSetDetailComponent } from "../base-card-set-detail-component/base-card-set-detail.component";
import {
  CardSetTransformationService,
  CoreService,
  DataService,
  DialogService,
  FormConfigurationService,
  SaveDataRequest,
  SaveFormEvent,
  SpinnerService
} from "dspx-core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AppDataService } from "../../services/app-data.service";
import { ResponseParserService } from "../../services/response-parser.service";
import { ErrorService } from "../../services/error.service";
import { API_ENDPOINT_KEYS, API_ENDPOINTS } from "../../constants/api-endpoints.constants";
import { TEMPLATES, VERSIONS } from "../../constants/templates.constants";
import { ROUTE_CONSTANTS } from "../../constants/route.constants";
import { POP_UP_CODES, SAVE_RESULT_STATUS } from "../../constants/app-data.constants";
import { finalize, take } from "rxjs";

@Component({
  selector: 'app-care-allowance-placement-bulk-ad-hoc-invoice-query',
  templateUrl: './care-allowance-placement-bulk-ad-hoc-invoice-query.component.html',
  styleUrl: './care-allowance-placement-bulk-ad-hoc-invoice-query.component.scss'
})
export class CareAllowancePlacementBulkAdHocInvoiceQueryComponent extends BaseCardSetDetailComponent implements OnInit, OnDestroy {

  protected readonly fieldTypeReplacements = CardSetTransformationService.cardSetWithFlatTabsFieldTypeReplacements;

  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;

  templateId: number = TEMPLATES.careAllowancePlacementBulkAdHocInvoiceQuery;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';
  viewMode: boolean = false;

  private routePrefix = '';
  private isEditing = false;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected changeDetector: ChangeDetectorRef,
    private coreService: CoreService,
    private errorService: ErrorService,
    private spinnerService: SpinnerService,
    private dataService: DataService,
    private formConfigurationService: FormConfigurationService
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {
    this.coreService.applicationFunctions = {
      displayBtnSave: () => !this.viewMode,
    };

    this.coreService.conditionFunctions = {
      isViewMode: () => this.viewMode
    }

    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      const id = paramMap.get('id');
      if (id) {
        this.id = id;
        this.formServiceEndpoint = API_ENDPOINT_KEYS.getCareAllowancePlacementBulkAdHocInvoiceQueryConfigAndResponse;
        this.isEditing = true;
      }
    });

    if (this.router.url.includes(ROUTE_CONSTANTS.careAllowancePlacementBulkAdHocInvoiceQuery.prefixViewQuery)) {
      this.viewMode = true;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded(event: any): void {

  }

  modelChanged(event: any): void {

  }

  filter(event: any): void {
  }

  buttonClicked(event: any): void {
  }

  save(event: SaveFormEvent) {
    const saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: event.isSubmit
    }
    if (!event.isFormValid) {
      this.baseForm.markAllFieldsAsTouched();
      if (!this.baseForm.fields[0]?.formControl.valid) {
        this.baseForm.showValidationSummary(true);
        this.dialogService.showDialog(POP_UP_CODES.common.validationError);
      }
      else {
        this.saveData(saveDataRequest);
      }
    }
    else {
      this.saveData(saveDataRequest);
    }
  }

  cancel(event: any) {
    this.exit();
  }

  dialogButton_saveSuccessful_Clicked(event: any) {
    this.exit(true);
  }

  private exit(ignoreUnsavedChanges = false) {
    this.navigate([ROUTE_CONSTANTS.careAllowancePlacementBulkAdHocInvoiceQuery.list], ignoreUnsavedChanges)
  }

  private saveData(request: SaveDataRequest) {
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.dataService.saveData(API_ENDPOINTS.careAllowancePlacementBulkAdHocInvoiceQuery.save, request)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            this.id = data.id;
            this.activeDialog = POP_UP_CODES.common.saveSuccessful;
            this.dialogService.showDialog(this.activeDialog);
          }
        })
    );
  }

}
